import React from 'react'
import Cards from "./Components/Cards"

const App = () => {
  return (
    <div className='App'>
    <h1>Memory Game</h1>
 
      <Cards/>
    </div>
  )
}

export default App

